import { forwardRef } from "react";
import { StyledTooltipCard } from "./Tooltip.styles";

/**
 * TooltipCard
 *
 * Pure visual **atom** that renders the tooltip shell and arrow.
 * Styling lives in `StyledTooltipCard` (see Tooltip.styles).
 *
 * Params
 * - children (React.ReactNode): tooltip text or JSX
 * - placement ("bottom" | "top"): flips arrow & vertical offset; default "bottom"
 * - style (React.CSSProperties): inline style object injected by the Tooltip molecule
 * - ...props (object): Any additional props are forwarded to
 *   `StyledTooltipCard` (e.g., `style`, `onClick`, `data-*` attributes).
 *
 * Returns
 * - JSX.Element: fixed‑positioned tooltip panel (rendered through a portal)
 */
const TooltipCard = forwardRef(function TooltipCard(
  { children, placement = "bottom", style, ...props },
  ref,
) {
  return (
    <StyledTooltipCard {...props} ref={ref} data-placement={placement} style={style}>
      {children}
    </StyledTooltipCard>
  );
});

export { TooltipCard };
